import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import date from "@common/lib/date";
import classNames from "classnames";
import { isNull } from "lodash";
import React from "react";
import { type TimelineAttachment, type TimelineItemInfo } from "./component";
import { getHtmlId } from "./lib";

const renderTitle = (title: any) =>
  typeof title === "string" ? <span dangerouslySetInnerHTML={{ __html: title }} /> : title;

type Props = {
  item: TimelineItemInfo;
  tag?: string;
};
type AttchmentProps = {
  items: TimelineAttachment[];
};

export const Attachments = (props: AttchmentProps) => {
  const i18n = useI18n();

  return !!props.items.length ? (
    <div className="attachments">
      {props.items.map((a, i) => (
        <div className="item" key={i}>
          <Icon icon={IconType.File} /> <span>{a.name}</span>
          <a href={a.url} download target="_blank">
            {<Icon icon={IconType.Download} />} {i18n.download}
          </a>
        </div>
      ))}
    </div>
  ) : null;
};
const TimelineItem = ({ item, tag }: Props) => {
  const Tag = (tag || ("div" as unknown)) as React.ComponentType<React.HTMLProps<any>>;

  return (
    <Tag
      id={getHtmlId(item.id)}
      className={classNames("item", item.className, {
        colored: !isNull(item.color),
        icon: !!item.icon,
        clickable: !!item.onClick
      })}
      onClick={item.onClick}
    >
      <span className="point" style={{ "--color": `var(--${item.color ?? "gray"})` } as any}>
        {item.icon ? typeof item.icon === "string" ? <Icon icon={item.icon} /> : item.icon : null}
      </span>
      <div className={classNames("content", item.className)}>
        <span className="header">
          {renderTitle(item.title)}

          {!item.isDateHidden && (
            <span className="time">
              <Icon icon={IconType.Clock} /> {date.formatDateTimeLocal(item.date)}
            </span>
          )}
        </span>
        {(!!item.content || !!item.attachments?.length) && (
          <div className="body">
            {!!item.content &&
              (typeof item.content === "string" ? (
                <span dangerouslySetInnerHTML={{ __html: item.content }} />
              ) : (
                item.content
              ))}
            {<Attachments items={item.attachments ?? []}></Attachments>}
          </div>
        )}
      </div>
      {item.addon}
    </Tag>
  );
};

export default TimelineItem;
